import { render, staticRenderFns } from "./CreativesPage.vue?vue&type=template&id=86586cca&scoped=true"
import script from "./CreativesPage.vue?vue&type=script&lang=js"
export * from "./CreativesPage.vue?vue&type=script&lang=js"
import style0 from "./CreativesPage.vue?vue&type=style&index=0&id=86586cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86586cca",
  null
  
)

export default component.exports